import http from '../utils/http'

const faultApi = {
    // 故障列表
    getFaultList(parame) {
        return http.post('http://10.200.170.8:6066/ckips/breakdown/list', parame)
    },

    // 故障处理
    getFaultHandling(id, status) {
        return http.post('http://10.200.170.8:6066/ckips/breakdown/handleBreakdown', {
            id: id,
            authStatus: status
        })
    }
}

export default faultApi
